// API client for /api/cards/:cardId/prompts + /api/cards/:cardId/notes + /api/sessions/:id/prompts
import { apiJson } from './client';

export interface Prompt {
  id: string;
  sessionId: string;
  cardId: string;
  promptText: string;
  source: 'cli' | 'voice' | 'chat';
  sentAt: string;
  sessionNumber: number;
  agentType: string;
}

export interface Note {
  id: string;
  cardId: string;
  authorUserId: string;
  authorDisplayName: string;
  body: string;
  createdAt: string;
  updatedAt: string;
  edited: boolean;
  /** Telegram-style reply target — the id of the note this one replies to. */
  replyToNoteId?: string | null;
}

export const promptsApi = {
  async listForCard(cardId: string): Promise<Prompt[]> {
    const r = await apiJson<{ prompts: Prompt[] }>(`/cards/${cardId}/prompts`);
    return r.prompts;
  },
  async record(
    sessionId: string,
    promptText: string,
    principalFence: string,
    source: 'cli' | 'voice' = 'cli',
  ): Promise<Prompt> {
    const r = await apiJson<{ prompt: Prompt }>(`/sessions/${sessionId}/prompts`, {
      method: 'POST',
      json: { promptText, source },
      headers: { 'X-Chaos-Expected-Principal': principalFence },
    });
    return r.prompt;
  },
};

export const notesApi = {
  async list(cardId: string): Promise<Note[]> {
    const r = await apiJson<{ notes: Note[] }>(`/cards/${cardId}/notes`);
    return r.notes;
  },
  async create(cardId: string, body: string, replyToNoteId?: string | null): Promise<Note> {
    const r = await apiJson<{ note: Note }>(`/cards/${cardId}/notes`, {
      method: 'POST',
      json: { body, replyToNoteId: replyToNoteId ?? null },
    });
    return r.note;
  },
  async update(noteId: string, body: string): Promise<Note> {
    const r = await apiJson<{ note: Note }>(`/notes/${noteId}`, {
      method: 'PATCH',
      json: { body },
    });
    return r.note;
  },
  async delete(noteId: string): Promise<void> {
    await apiJson<{ ok: boolean }>(`/notes/${noteId}`, { method: 'DELETE' });
  },
};
